import React from 'react';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useTranslation } from 'react-i18next';

// Image paths - using public folder references
const world = '/img/world.webp';
const inventory = '/img/inventory.webp';
const profile = '/img/profile.webp';
const guild = '/img/guild.webp';
const feed = '/img/feed.webp';

/**
 * Bottom navigation bar with main tabs and secondary menu items.
 *
 * @param {Object} props
 * @param {string} props.activeTab - Currently active tab name
 * @param {boolean} props.isAnyOverlayOpen - Whether any overlay (settings/marketplace/admin) is open
 * @param {boolean} props.isGM - Whether the current user is a Game Master
 * @param {Function} props.onTabChange - Callback when a tab is clicked
 * @param {Function} props.onMarketplace - Callback to open marketplace
 * @param {Function} props.onSettings - Callback to open settings
 * @param {Function} props.onAdministration - Callback to open administration
 */
function V3BottomNav({
    activeTab,
    isAnyOverlayOpen,
    isGM,
    onTabChange,
    onMarketplace,
    onSettings,
    onAdministration,
}) {
    const { t } = useTranslation();

    return (
        <nav className="bottom-nav">
            <button
                className={`nav-tab ${!isAnyOverlayOpen && activeTab === 'world' ? 'active' : ''}`}
                onClick={() => onTabChange('world')}
            >
                <img src={world} alt="World" className="tab-icon" />
                <span className="tab-label">{t('navigation.world')}</span>
            </button>
            <button
                className={`nav-tab ${!isAnyOverlayOpen && activeTab === 'inventory' ? 'active' : ''}`}
                onClick={() => onTabChange('inventory')}
            >
                <img src={inventory} alt="Inventory" className="tab-icon" />
                <span className="tab-label">{t('navigation.inventory')}</span>
            </button>
            <button
                className={`nav-tab ${!isAnyOverlayOpen && activeTab === 'hero' ? 'active' : ''}`}
                onClick={() => onTabChange('hero')}
            >
                <img src={profile} alt="Hero" className="tab-icon" />
                <span className="tab-label">{t('navigation.hero')}</span>
            </button>
            <button
                className={`nav-tab ${!isAnyOverlayOpen && activeTab === 'guild' ? 'active' : ''}`}
                onClick={() => onTabChange('guild')}
            >
                <img src={guild} alt="Guild" className="tab-icon" />
                <span className="tab-label">{t('navigation.guild')}</span>
            </button>
            <button
                className={`nav-tab ${!isAnyOverlayOpen && activeTab === 'feed' ? 'active' : ''}`}
                onClick={() => onTabChange('feed')}
            >
                <img src={feed} alt="Feed" className="tab-icon" />
                <span className="tab-label">{t('navigation.feed')}</span>
            </button>

            {/* Separator - only visible on desktop */}
            <div className="nav-separator"></div>

            {/* Additional menu items - only visible on desktop */}
            <button className="nav-tab nav-secondary" onClick={onMarketplace}>
                <img
                    src="/img/exchange.webp"
                    alt="Marketplace"
                    className="tab-icon"
                />
                <span className="tab-label">{t('navigation.marketplace')}</span>
            </button>

            <button className="nav-tab nav-secondary" onClick={onSettings}>
                <SettingsRoundedIcon className="tab-icon" sx={{ fontSize: 24 }} />
                <span className="tab-label">{t('navigation.settings')}</span>
            </button>

            {isGM && (
                <button className="nav-tab nav-secondary" onClick={onAdministration}>
                    <AdminPanelSettingsIcon className="tab-icon" sx={{ fontSize: 24 }} />
                    <span className="tab-label">{t('navigation.administration')}</span>
                </button>
            )}
        </nav>
    );
}

export default V3BottomNav;
